module.exports = __webpack_public_path__ + "img/yyjjfa_06.21167eb6.jpg";